// extracted by mini-css-extract-plugin
module.exports = {"service":"service-Y60eP","service__icon":"service__icon-3r6Kz","service__info":"service__info-1_-nv","service__name":"service__name-5QANI"};